// ------------ Inter Island Website ------------
/* 
  firestore location: Singapore
*/
import {isDev} from "./env"

export const firebaseConfig = isDev ? {
  // copy all these lines from "Add Firebase to your web app" setup guide.
  apiKey: "AIzaSyACRmAfxTUjROXRlNyt54BROIANbd2rfv0",
  authDomain: "interisland-front-end-preprod.firebaseapp.com",
  projectId: "interisland-front-end-preprod",
  storageBucket: "interisland-front-end-preprod.appspot.com",
  messagingSenderId: "402487232478",
  appId: "1:402487232478:web:bf79df4a931ca9bfbb3f4f",
  measurementId: "G-E0QC56XMN5" // Google Analytics
} : {
  apiKey: "AIzaSyCdls3CuHduiKGsTIISmYMGAw9e0ibfCaI",
  authDomain: "interisland-front-end-prod.firebaseapp.com",
  projectId: "interisland-front-end-prod",
  storageBucket: "interisland-front-end-prod.appspot.com",
  messagingSenderId: "719689799898",
  appId: "1:719689799898:web:9be29193f0f93662066de3",
  measurementId: "G-9HHWB56118" // Google Analytics
}

// standard system fields for email of new contact form:
export const client_id = isDev ? "interIsland_preprod" : "interIsland_prod"
export const client_name = isDev ? "InterIsland Group Preprod" : "InterIsland Group"
export const client_emails = isDev ? ["andyliao@aria-it.com"] : ["hello@interislandgroup.com"]
